module.exports = __webpack_public_path__ + "static/portfolio-mas-2-f6fd0ad350667367b92cc8cd27193cac.jpg";